import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
/* eslint-disable standard/no-callback-literal */
import Echo from 'laravel-echo';
import Vue from 'vue';
import { axiosInstance } from "./axios";
window.Pusher = require('pusher-js');
var echoInstance;
export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var authorization;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        // Get authorization token
        authorization = ''; // let token
        try {
          // authorization = 'Bearer ' + token
        } catch (e) {} finally {
          echoInstance = new Echo({
            broadcaster: 'pusher',
            authEndpoint: process.env.API_URL + '/api/broadcasting/auth',
            key: process.env.MIX_PUSHER_APP_KEY,
            cluster: process.env.MIX_PUSHER_APP_CLUSTER,
            forceTLS: true,
            authorizer: function authorizer(channel) {
              return {
                authorize: function authorize(socketId, cb) {
                  axiosInstance.post('/api/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name
                  }, {
                    withCredentials: true
                  }).then(function (response) {
                    cb(false, response.data);
                  }).catch(function (error) {
                    cb(true, error);
                  });
                }
              };
            }
          });
          Vue.prototype.$echo = echoInstance;

          // Define $api...
          axiosInstance.interceptors.request.use(function (config) {
            config.headers['X-Socket-ID'] = echoInstance.socketId();
            return config;
          });
          axiosInstance.defaults.headers.common['Authorization'] = authorization;
          Vue.prototype.$api = axiosInstance;
        }
      case 2:
      case "end":
        return _context.stop();
    }
  }, _callee);
}));
export { echoInstance };